module.exports = __webpack_public_path__ + "static/ICONS_COMMON_SVG-36-ee143b3bb7330a3e1c907ce093442620.svg";